import produce from "immer";
import {
  LOADER_STATUS,
  SET_MASTER_MODULE,
  SET_ADD_MODULE_MODAL,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  isModalActive: false,
  masterModules: [],
};

const manageModuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_MASTER_MODULE:
      return {
        ...state,
        masterModules: action.masterModules,
      };
    case SET_ADD_MODULE_MODAL:
      return {
        ...state,
        isModalActive: action.isModalActive,
      };
    default:
      return state;
  }
};

export default manageModuleReducer;
